import script from "./CheckAmazonGoodsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckAmazonGoodsModal.vue?vue&type=script&lang=ts&setup=true"

import "./CheckAmazonGoodsModal.vue?vue&type=style&index=0&id=38f29712&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f29712"]])

export default __exports__